import Storage from 'sources/localStorage/Storage';
import uuid from 'node-uuid';
import normalizeFormToStringValues from 'components/helpers/normalizeFormToStringValues';

class RegistrationFormStorageHandler {
    constructor() {
        this.token = null;
    }

    init() {
        this.token = localStorage.getItem('registrationToken');
        if (!this.token) {
            this.token = uuid.v4();
            localStorage.setItem('registrationToken', this.token);
        }
    }

    getFormData() {
        if (!this.token) return Promise.resolve({});

        const jsonForm = localStorage.getItem(this.token);

        if (!jsonForm) return Promise.resolve({});

        const state = {...JSON.parse(jsonForm)};

        const jsonAttachmentsKeys = localStorage.getItem(`${this.token}_attachments`);
        if (!jsonAttachmentsKeys) return Promise.resolve(state);
        const attachmentsKeys = JSON.parse(jsonAttachmentsKeys);

        return !Storage.isInitialized()
            ? Storage.init().then(this.fetchAttachments.bind(this, state, attachmentsKeys))
            : this.fetchAttachments(state, attachmentsKeys);
    }

    fetchAttachments(state, attachmentsKeys) {
        return Promise.all(attachmentsKeys.map((data) => Storage.getAttachment(this.token, data.key).then((attachment) => ({[data.key]: attachment.slice(0, attachment.size, data.type)})))).then((fetchedAttachments) => {
            const attachments = {};
            fetchedAttachments.forEach((a) => {
                Object.keys(a).forEach((key) => {
                    attachments[key] = a[key];
                });
            });
            return attachments;
        }).then((attachments) => ({
            ...state,
            ...attachments,
        }));
    }


    saveFormData(state) {
        const {
            avatar, cv, medicalDiploma, residencyDiploma, pharmacyCertificate, stateMedicalLicences, signature, ...otherFields
        } = state;
        localStorage.setItem(this.token, JSON.stringify(normalizeFormToStringValues({...otherFields})));
        const attachments = {
            avatar, cv, medicalDiploma, residencyDiploma, pharmacyCertificate, stateMedicalLicences,
        };

        if (!isNeedToSaveAttachment(attachments)) return Promise.resolve();

        if (!Storage.isInitialized()) {
            return Storage.init()
                .then(this.saveAttachments.bind(this, attachments));
        }
        return this.saveAttachments(attachments);
    }

    saveAttachments(attachments) {
        const savedKeys = [];
        return Promise.all(Object.keys(attachments).map((attachmentKey) => {
            const attachment = attachments[attachmentKey];
            if (!attachment) return;
            savedKeys.push({type: attachment.type, key: attachmentKey});
            return Storage.setAttachment(this.token, attachmentKey, attachment);
        })).then(() => {
            localStorage.setItem(`${this.token}_attachments`, JSON.stringify(savedKeys));
        });
    }

    clear() {
        if (!this.token) return Promise.resolve();

        const jsonForm = localStorage.getItem(this.token);

        if (!jsonForm) return Promise.resolve();

        localStorage.removeItem(this.token);

        const jsonAttachmentsKeys = localStorage.getItem(`${this.token}_attachments`);
        localStorage.removeItem(`${this.token}_attachments`);
        if (!jsonAttachmentsKeys) return Promise.resolve();

        const attachmentsKeys = JSON.parse(jsonAttachmentsKeys);
        return !Storage.isInitialized()
            ? Storage.init().then(this.removeAttachments.bind(this, attachmentsKeys))
            : this.removeAttachments(attachmentsKeys);
    }

    removeAttachments(attachmentsKeys) {
        return Promise.all(attachmentsKeys.map((data) => Storage.removeAttachment(this.token, data.key)));
    }
}


function isNeedToSaveAttachment(attachments) {
    return Object.keys(attachments).some((key) => Boolean(attachments[key]));
}

export default new RegistrationFormStorageHandler();



// WEBPACK FOOTER //
// ./src/components/Auth/Register/RegistrationFormStorageHandler.js